import { motion } from "framer-motion";
import type { StateCardProps } from "./types";
import { StateCardContext } from "./StateCardContext";

export function StateCardRoot({
  variant,
  children,
  className,
}: StateCardProps) {
  return (
    <StateCardContext value={{ variant }}>
      <motion.div
        className={`flex flex-col items-center gap-3 rounded-xl border border-border bg-card p-4 ${className ?? ""}`}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        {children}
      </motion.div>
    </StateCardContext>
  );
}
